import { render, staticRenderFns } from "./despesasReceitas.vue?vue&type=template&id=33cb24da&scoped=true&"
import script from "./despesasReceitas.vue?vue&type=script&lang=js&"
export * from "./despesasReceitas.vue?vue&type=script&lang=js&"
import style0 from "./despesasReceitas.vue?vue&type=style&index=0&id=33cb24da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33cb24da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VCheckbox,VDataTable,VList,VListItem,VListItemTitle,VMenu,VProgressCircular})
